import type {
  InsertColourPaletteMutation,
  Scalars,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface InsertColourPaletteTRPCInput {
  Name: string;
  Settings: Scalars['jsonb']['input'];
}

/**
 * Maps TRPC mutation response to match the GraphQL mutation structure
 */
const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): InsertColourPaletteMutation => {
  return {
    insert_colour_palette_one: {
      __typename: 'colour_palette',
      Id: trpcData.Id,
    },
  };
};

export const useInsertColourPaletteTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.colourPalette.insert.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.colourPalette.getColourPalettes.queryKey(),
        });
      },
    }),
  });

  return {
    insertColourPalette: async (
      variables: InsertColourPaletteTRPCInput
    ): Promise<InsertColourPaletteMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
